export default [
    {
        "error_id": "ENCRS-01",
        "data": [
            {
                "cross_section": "45361"
            },
            {
                "cross_section": "45472"
            },
            {
                "cross_section": "50950"
            },
            {
                "cross_section": "52313"
            },
            {
                "cross_section": "52702"
            },
            {
                "cross_section": "53040"
            }
        ],
        "originalData": [
            {
                "cross_section": "53040"
            },
            {
                "cross_section": "52702"
            },
            {
                "cross_section": "52313"
            },
            {
                "cross_section": "50950"
            },
            {
                "cross_section": "45472"
            },
            {
                "cross_section": "45361"
            }
        ]
    },
    {
        "error_id": "ENCRS-02",
        "data": [
            {
                "cross_section": "9279"
            },
            {
                "cross_section": "24510"
            },
            {
                "cross_section": "45345"
            },
            {
                "cross_section": "45404"
            },
            {
                "cross_section": "45484"
            },
            {
                "cross_section": "57191"
            },
            {
                "cross_section": "58795"
            }
        ],
        "originalData": [
            {
                "cross_section": "58795"
            },
            {
                "cross_section": "57191"
            },
            {
                "cross_section": "45484"
            },
            {
                "cross_section": "45404"
            },
            {
                "cross_section": "45345"
            },
            {
                "cross_section": "24510"
            },
            {
                "cross_section": "9279"
            }
        ]
    }
]